import { localValues, } from "@/storage/browser"
import { DevicePreference, removePersisted } from "@/storage/persist"
import { appPath } from "@/utils/navigation"

export async function purgeFleetWorkspaceState() {
  await Promise.all([
    removePersisted(DevicePreference.global("globalSync.project")),
    removePersisted(DevicePreference.global("layout")),
    removePersisted(DevicePreference.global("server.v4")),
  ])

  try {
    const keys: string[] = []
    for (let i = 0; i < localValues.length; i++) {
      const key = localValues.key(i)
      if (!key) continue
      if (key.startsWith("mux.workspace.")) keys.push(key)
    }
    for (const key of keys) localValues.removeItem(key)
  } catch {
    // Storage cleanup is best-effort; the server registry delete already succeeded.
  }
}

export async function reloadIntoEmptyFleet() {
  await purgeFleetWorkspaceState()
  window.location.assign(appPath("/machines"))
}
